import React, { forwardRef } from 'react';
import classNames from 'classnames';

const PopupFormTemplate = forwardRef(
  ({ children, disabled, position, onSubmit = undefined, onClose = undefined }, menuRef) => {
    const handleCancelClick = (e) => {
      e.stopPropagation();
      if (onClose) onClose();
    };

    const handleSubmitClick = (e) => {
      e.stopPropagation();
      if (onSubmit) onSubmit();
      if (onClose) onClose();
    };

    return (
      <div
        ref={menuRef}
        style={{
          top: position.top ?? '35px',
          right: position.right ?? 'unset',
          bottom: position.bottom ?? 'unset',
          left: position.left ?? 0,
          position: 'absolute',
          zIndex: 1000,
          borderRadius: '5px',
          boxShadow: ' 0 5px 10px 5px rgb(89 102 109 / 17%)',
          boxSizing: 'border-box',
          height: 'auto',
          background: 'var(--bg-textarea)',
          padding: '20px',
          minWidth: '400px',
          border: '1px solid var(--color-brand)',
        }}
      >
        {children}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <button
            className={classNames('button_default', 'save_style')}
            onClick={handleSubmitClick}
            disabled={disabled}
          >
            Сохранить
          </button>
          <button
            className={classNames('button_default', 'cancel_style')}
            onClick={handleCancelClick}
          >
            Отмена
          </button>
        </div>
      </div>
    );
  },
);

export default PopupFormTemplate;
